import { useEffect, useState } from "react";
import { ItemDetails } from "../../components/itemComponents/ItemDetails";
import { fetchItems } from "../../utils/fetchItemData";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import { buildItemSocialMeta, applySocialMeta } from "../../utils/socialMeta";

const ItemDirect = () => {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleGetData = async () => {
      try {
        setLoading(true);
        const data = await fetchItems({ itemId });

        if (data?.[0]) {
          const itemData = data[0];
          setItem(itemData);
          applySocialMeta(buildItemSocialMeta(itemData, `https://pixelore.wiki${location.pathname}`));
        } else {
          setError("Item not found");
          applySocialMeta(buildItemSocialMeta(null, `https://pixelore.wiki${location.pathname}`));
        }
      } catch (err) {
        console.error("Failed to fetch item:", err);
        setError("Failed to load item");
        applySocialMeta(buildItemSocialMeta(null, `https://pixelore.wiki${location.pathname}`));
      } finally {
        setLoading(false);
      }
    };

    handleGetData();
  }, [itemId, location.pathname]);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="panel-style p-4 text-[var(--text-color)]">
      <button onClick={() => navigate(-1)} className="mb-4 flex items-center gap-2 text-primary hover:underline">
        ← Back
      </button>
      {error && (error)}
      <ItemDetails item={item} />
    </div>
  );
};

export default ItemDirect;
